const home = $('body').hasClass('home')
const projectOpen = $('.cd-folding-panel').hasClass('is-open')

module.exports = function homeCarousel() {

    if (home) {
        import('owl.carousel2').then((owlCarousel) => {


            $('.owl-carousel').owlCarousel({
                loop: true,
                items: 1,
                autoplay: true,
                loop: true,
                autoplayTimeout: 5000,
                autoplaySpeed: 500,
                dots: false,
                animateOut: 'fadeOut',
                responsive: {
                    0: {
                        nav: false
                    },
                    1024: {
                        nav: true
                    }
                }
            })

        })

    }
}